import { Button, ButtonProps, Stack, styled } from '@mui/material';
import { COLOR_ACCENT_DARK, COLOR_BG_SECONDARY, COLOR_BLACK } from 'shared';

const StyledButton = styled(Button)<ButtonProps>({
  backgroundColor: COLOR_BG_SECONDARY,
  width: '100%',
  padding: 16,
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: COLOR_ACCENT_DARK,
    '& p': { color: COLOR_BLACK },
    '& svg': { color: COLOR_BLACK },
  },
});

export const PaymentButton = ({ children, ...props }: ButtonProps) => {
  return (
    <StyledButton {...props}>
      <Stack direction="row" gap={1} alignItems="center">
        {children}
      </Stack>
    </StyledButton>
  );
};
